import React from 'react';
import { Link } from 'react-router-dom';

const variantStyles = {
  light: {
    container: 'border-t border-slate-200/80 text-slate-500',
    link: 'text-slate-600 hover:text-pink-600',
    copy: 'text-slate-400',
  },
  inverse: {
    container: 'border-t border-white/20 text-white/75',
    link: 'text-white/85 hover:text-white',
    copy: 'text-white/60',
  },
  dark: {
    container: 'border-t border-zinc-800 text-zinc-400',
    link: 'text-zinc-300 hover:text-white',
    copy: 'text-zinc-500',
  },
};

const LegalFooter = ({ variant = 'light', className = '' }) => {
  const styles = variantStyles[variant] || variantStyles.light;
  const currentYear = new Date().getFullYear();

  return (
    <div className={`mt-10 ${className}`}>
      <div className={`mx-auto max-w-5xl px-4 py-6 text-center text-xs ${styles.container}`}>
        <div className="flex flex-wrap items-center justify-center gap-x-5 gap-y-2">
          <Link to="/privacy" className={`font-medium transition-colors ${styles.link}`}>
            Privacy Policy
          </Link>
          <Link to="/terms" className={`font-medium transition-colors ${styles.link}`}>
            Terms of Service
          </Link>
        </div>
        <p className={`mt-3 ${styles.copy}`}>© {currentYear} Fluffball</p>
      </div>
    </div>
  );
};

export default LegalFooter;
